//#region src/modules/FormBuilder/components/Fields/Divider/Config.tsx
var DividerFieldConfig = ({ config, setOptions, setOptionsKey }) => {
	return null;
};
//#endregion
export { DividerFieldConfig };

//# sourceMappingURL=Config.js.map